import { createRoot } from 'react-dom/client';
import { StrictMode, Suspense, lazy } from 'react';
import { type KcContext, KcPage } from './keycloak-theme/kc.gen';

// Lazy load your main app to keep bundle size small for Keycloak pages
// eslint-disable-next-line @typescript-eslint/promise-function-async
const AppEntrypoint = lazy(() => import('./index.app'));

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      {window.kcContext ? (
        // Running inside Keycloak - show login/register pages
        <KcPage kcContext={window.kcContext} />
      ) : (
        // Running as normal app - show your application
        <Suspense>
          <AppEntrypoint />
        </Suspense>
      )}
    </StrictMode>
  );
}

// Declare the global kcContext that Keycloak will inject
declare global {
  interface Window {
    kcContext?: KcContext;
  }
}
